import { APP_BASE_HREF, HashLocationStrategy, Location, LocationStrategy } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApPegaModule } from '@ap/pega';

// @ts-ignore: Needs to be ignored so the typescript compiler replaces BASE_HREF
export const baseHref: string = BASE_HREF;

@NgModule({
    imports: [ApPegaModule],
    providers: [
        {
            provide: APP_BASE_HREF,
            useValue: baseHref
        },
        Location,
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        }
    ]
})
export class SamenRekeningOpenenModule {}
